import React, { useState } from "react";
import { Alert, Box, Button, Container, TextField, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import currency from "currency.js";

export default function CashEntry(props) {
  const { amountDue } = props;
  const navigate = useNavigate();

  const [paid, setPaid] = useState("");

  const [error, setError] = useState("");

  const setPaidAmount = (amount) => {
    setPaid(amount);
    props.onChange({
      tendered: currency(amount, { fromCents: true }).value,
      change: currency(Math.abs(+amountDue - +amount), { fromCents: true }).value,
    });
  };

  const getButton = (key) => {
    return (
      <Button
        variant="contained"
        onClick={(e) => {
          if (key === "⌫") {
            setPaidAmount(`${paid}`.slice(0, -1));
          } else {
            const newAmount = `${paid}${key}`;
            console.log(newAmount);
            setPaidAmount(newAmount);
          }
        }}
        sx={{
          height: "5rem",
          width: "5rem",
          fontWeight: "700",
          fontSize: "2rem",
          backgroundColor: "#DEDEDE",
          color: "#333",
          "&:hover": {
            backgroundColor: "#DEDEDE",
          },
        }}
      >
        {key}
      </Button>
    );
  };

  const getQuickPickButton = (value) => {
    return (
      <Button
        variant="contained"
        onClick={(e) => {
          if (value === "C") {
            setPaidAmount("");
          } else {
            setPaidAmount(currency(value, { fromCents: true }).intValue);
          }
        }}
        sx={{
          height: "5rem",
          width: "7rem",
          fontSize: "1.3rem",
          backgroundColor: "#CECECE",
          color: "#333",
          "&:hover": {
            backgroundColor: "#CECECE",
          },
        }}
      >
        {value === "C" ? "C" : currency(value, { fromCents: true, precision: 2 }).format()}
      </Button>
    );
  };

  let quickPicks = new Set();
  // first is next integer
  if (+amountDue > 0) {
    quickPicks.add(amountDue);
    quickPicks.add(Math.ceil(amountDue / 100) * 100);
    quickPicks.add(Math.ceil(amountDue / 500) * 500);
    quickPicks.add(Math.ceil(amountDue / 1000) * 1000);
    quickPicks.add(Math.ceil(amountDue / 2000) * 2000);
    quickPicks.add(Math.ceil(amountDue / 5000) * 5000);
    quickPicks.add(Math.ceil(amountDue / 10000) * 10000);
  }

  if (+amountDue < 500) {
    quickPicks.add(500);
  }
  if (+amountDue < 1000) {
    quickPicks.add(1000);
  }
  if (+amountDue < 2000) {
    quickPicks.add(2000);
  }
  if (+amountDue < 5000) {
    quickPicks.add(5000);
  }
  if (+amountDue < 10000) {
    quickPicks.add(10000);
  }

  quickPicks = Array.from(quickPicks);

  return (
    <Container maxWidth="xs" sx={{ backgroundColor: "#F7F7F7" }}>
      <Box pb={2}>
        {error && (
          <Box>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
        <Box>
          <Paper elevation={0} sx={{ backgroundColor: "#F7F7F7", color: "#333" }}>
            <Box sx={{ display: "flex", gap: "1rem", padding: "0.5rem" }}>
              <Box pr={2} sx={{ borderRight: "1px solid #999", width: "5rem" }}>
                <Typography variant="caption" color="textSecondary">
                  Due
                </Typography>
                <Typography variant="body1">
                  {currency(amountDue, { fromCents: true }).format()}
                </Typography>
              </Box>
              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                <Typography variant="caption" color="textSecondary">
                  Tendered
                </Typography>
                <Typography variant="body1">
                  {currency(paid, { fromCents: true }).format()}
                </Typography>
              </Box>
              <Box pl={2} sx={{ borderLeft: "1px solid #999", width: "7rem", textAlign: "right" }}>
                <Typography variant="caption" color="textSecondary">
                  Change
                </Typography>
                <Typography variant="body1">
                  {paid >= amountDue
                    ? currency(Math.abs(+amountDue - +paid), { fromCents: true }).format()
                    : currency(0).format()}
                </Typography>
              </Box>
            </Box>
          </Paper>
          <Box my={2} sx={{ display: "flex", gap: "1rem" }}>
            {[7, 8, 9].map((num) => getButton(num))}
            {getQuickPickButton(quickPicks[0])}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem" }}>
            {[4, 5, 6].map((num) => getButton(num))}
            {quickPicks.length > 1 && getQuickPickButton(quickPicks[1])}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem" }}>
            {[1, 2, 3].map((num) => getButton(num))}
            {quickPicks.length > 2 && getQuickPickButton(quickPicks[2])}
          </Box>
          <Box mt={2} sx={{ display: "flex", gap: "1rem" }}>
            {["⌫", 0, "00"].map((num) => getButton(num))}
            {getQuickPickButton("C")}
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
